import { css } from 'styled-components';

const styles = css`
  .accountDrawer {
    .linksWrapper {
      background-color: ${(props) => props.theme.colors.WHITE};
      padding: ${(props) => `${props.theme.spacing.ELEM_SPACING.MED} 25px 0px`};
    }
  }
  .accountDashboard {
    .linksWrapper {
      background-color: ${(props) => props.theme.colorPalette.gray[3400]};
      padding: ${(props) =>
        `${props.theme.spacing.ELEM_SPACING.MED} 25px ${props.theme.spacing.ELEM_SPACING.MED}`};
    }
  }
  .link-text-container {
    display: flex;
    align-items: center;
    line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-size: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-weight: 400;
  }
  .bottomLinks {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  .link-image {
    width: 24px;
    height: 24px;
    margin-right: 28px;
  }
  .link-icon {
    width: 24px;
    height: 24px;
  }
  .sign-out-wrapper {
    padding: 24px 25px 80px;
  }
  .sign-out-icon {
    display: flex;
    align-items: center;
    text-decoration: underline;
  }
  .divider {
    padding-top: ${(props) => (!props.showDashboardBottomLink ? '6px' : '0')};
    border-bottom: 1px solid ${(props) => props.theme.colorPalette.gray[3200]};
  }

  .hideLinks {
    display: none;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      display: ${(props) => (props.showDashboardBottomLink ? 'block' : 'none')};
      background: ${(props) => props.theme.colorPalette.gray[3400]};
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      display: ${(props) => (props.showDashboardBottomLink ? 'block' : 'none')};
      background: ${(props) => props.theme.colorPalette.gray[3400]};
    }
  }
`;

export default styles;
